"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumCharges = exports.useGenerateCharges = exports.useGenerateConsumptionCharges = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var groupBy_1 = require("../../../../../../../shared/core/utils/groupBy");
var number_1 = require("../../../../../../../shared/core/utils/number");
var copy_1 = require("../../../../../copy");
var consumptionTools_1 = require("./consumptionTools");
/**
 * Generates rows with correctly formatted labels, values, and contexts based on
 * the consumption rates provided. Adapted from similar function:
 * ../charges-in-detail/fuel/FuelSection.tsx
 **/
var useGenerateConsumptionCharges = function (supplyPointRegisterCharges) {
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return supplyPointRegisterCharges
        .map(function (supplyPointRegisterCharge) {
        var multiRateGroups = Object.entries((0, groupBy_1.groupBy)(supplyPointRegisterCharge.consumptionRates, function (a) { return a.friendlyLabel; }));
        return multiRateGroups.map(function (_a) {
            var _b = __read(_a, 2), label = _b[0], consumptionBlocks = _b[1];
            var nonUniqueConsumptionBlock = consumptionBlocks.length !== 1;
            var totalCost = (0, number_1.sum)(consumptionBlocks.map(function (_a) {
                var pounds = _a.cost.pounds;
                return Number(pounds);
            }));
            return {
                label: supplyPointRegisterCharge.isMultiRate ? (react_1.default.createElement(Copy, { copyKey: "multiRateChargeLabel", props: { friendlyLabel: label } })) : (react_1.default.createElement(Copy, { copyKey: "chargeLabel" })),
                value: totalCost,
                context: (0, consumptionTools_1.determineConsumptionBlockReason)(consumptionBlocks).map(function (consumptionBlock) {
                    // TODO: rollout copy tooling: CPCE-1846
                    return (0, consumptionTools_1.consumptionContext)(label, consumptionBlock, nonUniqueConsumptionBlock);
                }),
            };
        });
    })
        .reduce(function (a, b) { return a.concat(b); }, []);
};
exports.useGenerateConsumptionCharges = useGenerateConsumptionCharges;
var useGenerateCharges = function (standing, supplyPointRegisterCharges) {
    var charges = [];
    var consumptionCharges = (0, exports.useGenerateConsumptionCharges)(supplyPointRegisterCharges);
    consumptionCharges.length && charges.push.apply(charges, __spreadArray([], __read(consumptionCharges), false));
    standing.rates.length &&
        charges.push({
            // TODO: rollout copy tooling: CPCE-1846
            label: 'Standing charge',
            value: Number(standing.netCharge.pounds),
            context: (0, consumptionTools_1.standingContexts)(standing.rates), // TODO: rollout copy tooling: CPCE-1846
        });
    return charges;
};
exports.useGenerateCharges = useGenerateCharges;
var sumCharges = function (charges) {
    return Number(charges
        .reduce(function (acc, _a) {
        var value = _a.value;
        return acc + Number(value.toFixed(2));
    }, 0)
        .toFixed(2));
};
exports.sumCharges = sumCharges;
